export default "__VITE_ASSET__CbO1z3cn__"